<breadcrumb [breadcrumbList]="breadcrumbList"></breadcrumb>
<div *ngIf="pageLoading1" class="loader text-center">
	<img src="../../../assets/img/loading.gif" style="width: 100px;" />
	<p style="color: black;font-weight: bolder;">Loading...</p>
</div>

<div class="card">
	<div class="card-header bg-theme">
		<h5 class="card-title pt-1 text-light mb-0">
			Case Details
			<span class="float-end text-light me-3">
				Case-Id:
				<strong>
					{{caseDetails?.case_id}}
				</strong>
			</span>
			<span class="float-end text-light me-3">
				<strong>
					<fa-icon [icon]="['fas',caseDetails?.status==2?'lock':'lock-open']"
						[matTooltip]="caseDetails?.case_status">
					</fa-icon>
				</strong>
			</span>
		</h5>
	</div>
	<div class="card-body">
		<div class="row mb-2">
			<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
				<strong>Name&nbsp;&nbsp;:&nbsp;&nbsp;</strong>
				{{caseDetails?.f_name}} {{caseDetails?.l_name}}
			</div>
			<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
				<strong>DOB&nbsp;&nbsp;:&nbsp;&nbsp;</strong>
				{{caseDetails?.dob || "___"}}
			</div>
			<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
				<strong>Rank&nbsp;&nbsp;:&nbsp;&nbsp;</strong>
				{{caseDetails?.rank_name || "___"}}
			</div>
			<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
				<strong>Vessel&nbsp;&nbsp;:&nbsp;&nbsp;</strong>
				{{caseDetails?.vessel || "___"}}
			</div>
		</div>
	</div>
</div>
<div class="card">
	<div class="card-body">
		@if(showMedHistory){
		<div class="row mb-2">
			<div class="col">
				<h3 class="fw-bold">
					Medicines
					<button class="btn btn-primary btn-xs ms-1" (click)="medSection()">
						<fa-icon [icon]="['fas',medArray.length?'edit':'plus']"></fa-icon>
						{{medArray.length?'Edit':'Add'}}
					</button>
				</h3>
				<p *ngIf="medArray.length == 0">No medicines added.</p>
			</div>
			<div class="col">
				<button *ngIf="medArray.length" class="btn btn-primary btn-xs float-end"
					(click)="copyMedicinesToClipBoard(1)" id="selectElementContentsBtn1">
					Copy to clipboard
				</button>
			</div>
		</div>
		<div class="row mb-2" *ngIf="printPrescArray.length > 0">
			<!-- <div class="col-sm-3">
				<label>Details on pdf:</label>
				<br />
				<mat-radio-group [(ngModel)]="prescriptionPara.prescUserType">
					<mat-radio-button [value]="'Candidate'" [color]="'primary'">
						Candidate
					</mat-radio-button>
					<mat-radio-button [value]="'Vessel'" [color]="'primary'">
						Vessel
					</mat-radio-button>
				</mat-radio-group>
			</div> -->
			<div class="col-sm-7">
				<div class="form-floating">
					<textarea [(ngModel)]="prescriptionPara.chief_complaint" class="form-control" placeholder=""
						id="chief_complaint"></textarea>
					<label for="chief_complaint">Chief Complaint</label>
				</div>
			</div>
			<div class="col-sm-5">
				<ng-select [items]="doctorList" bindLabel="name" placeholder="Doctor*"
					[(ngModel)]="prescriptionPara.prescDoctor" appearance="outline" plac>
				</ng-select>
				<button class="btn btn-success btn-xs float-end mt-2" (click)="loadPdf()"
					[disabled]="generatePdfLoader">
					<fa-icon [icon]="['fas','spinner']" [animation]="'spin'" *ngIf="generatePdfLoader"></fa-icon>
					Download Prescription
				</button>
			</div>
		</div>
		<div class="row mb-2">
			<div class="col">
				<table class="table table-bordered" *ngIf="medArray.length > 0" id="medicineTable"
					data-tableName="Test Table 2">
					<thead>
						<tr>
							<th>
								Select
								<button class="btn btn-xs btn-primary ms-1" *ngIf="printPrescArray.length > 0"
									matTooltip="Clear" (click)="clearPrescArray()">
									<fa-icon [icon]="['fas','sync-alt']"></fa-icon>
								</button>
							</th>
							<th>Date</th>
							<th>Name</th>
							<th>Dosage</th>
							<th>Frequency</th>
							<th>Meals</th>
							<th>No. Of Days</th>
							<th>Status</th>
							<th>Notes</th>
							<th>Added By</th>
							<th>Updated By</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let field of medArray; let i = index">
							<td>
								<mat-checkbox [color]="'primary'" [(ngModel)]="field.isChecked"
									(change)="checkValue(field,i,$event)"></mat-checkbox>
							</td>
							<td>
								{{field.medDate | date }}
							</td>
							<td>
								{{field.name}}
							</td>
							<td>
								{{field.qty}}
							</td>
							<td>
								{{getFrequencyText(field)}}
							</td>
							<td>
								{{field.meals}}
							</td>
							<td>
								{{field.noOfDays}}
							</td>
							<td>
								{{field.status}}
							</td>
							<td>
								{{field.notes}}
							</td>
							<td>
								{{field.addedBy}}
							</td>
							<td>
								{{field.updatedBy}}
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		}@else {
		<div class="row">
			<div class="col">
				<table class="table table-bordered med-table">
					<thead>
						<tr>
							<th style="width: 10% !important;"><span style="color: #b40a09;">*&nbsp;</span> Date</th>
							<th style="width: 25% !important;"><span style="color: #b40a09;">*&nbsp;</span> Medicine
							</th>
							<th style="width: 10% !important;">Dosage</th>
							<th style="width: 10% !important;">Frequency
							</th>
							<th style="width: 10% !important;">Meals</th>
							<th style="width: 10% !important;">No. Of Days
							</th>
							<th style="width: 10% !important;">Notes</th>
							<th style="width: 10% !important;">Status</th>
							<th style="width: 5% !important;">Action</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let field of medArray; let i = index">
							<td>
								<input class="form-control" placeholder="" [(ngModel)]="field.medDate" ngbDatepicker
									id="medDate{{i}}" #medDate="ngbDatepicker" [minDate]="minDate" [container]="'body'"
									(click)="medDate.toggle()" />
							</td>
							<td>
								<ng-container *ngIf="field.isSaved">{{field.name}}</ng-container>
								<ng-container *ngIf="!field.isSaved">
									<div class="ng-autocomplete">
										<ng-autocomplete [(ngModel)]="field.name" id="field_name{{i}}"
											[data]="medicineMaster" placeholder="Medicine*"
											historyIdentifier="medicineMaster" [itemTemplate]="medItemTemplate"
											[notFoundTemplate]="medNotFoundTemplate"
											(inputChanged)="onInputChanged($event,i)" [debounceTime]="500"
											[minQueryLength]="1" [isLoading]="isLoading==i"
											placeholder="Search medicines..."></ng-autocomplete>
										<ng-template #medItemTemplate let-item>
											<a [innerHTML]="item"></a>
										</ng-template>
										<ng-template #medNotFoundTemplate let-notFound>
											<div [innerHTML]="notFound"></div>
										</ng-template>
									</div>
								</ng-container>
							</td>
							<td>
								<input class="form-control" [(ngModel)]="field.qty" placeholder="" id="field_qty{{i}}">
							</td>
							<td>
								<mat-checkbox [color]="'primary'" [(ngModel)]="field.morning" id="field_morning{{i}}">
									Morning
								</mat-checkbox>
								<br />
								<mat-checkbox [color]="'primary'" [(ngModel)]="field.afternoon"
									id="field_afternoon{{i}}">
									Afternoon
								</mat-checkbox>
								<br />
								<mat-checkbox [color]="'primary'" [(ngModel)]="field.evening" id="field_evening{{i}}">
									Evening
								</mat-checkbox>
								<br />
								<mat-checkbox [color]="'primary'" [(ngModel)]="field.sos" id="field_sos{{i}}">
									SOS
								</mat-checkbox>
							</td>
							<td>
								<select class="form-select" [(ngModel)]="field.meals" id="field_meals{{i}}">
									@for (item of mealsList; track $index) {
									<option [value]="item">{{item}}</option>
									}
								</select>
							</td>
							<td>
								<input class="form-control" type="number" [(ngModel)]="field.noOfDays" placeholder=""
									id="field_noOfDays{{i}}">
							</td>
							<td>
								<input class="form-control" [(ngModel)]="field.notes" placeholder=""
									id="field_notes{{i}}">
							</td>
							<td>
								{{field.status}}
							</td>
							<td>
								<button class="btn btn-danger btn-xs" matTooltip="Remove" type="button"
									(click)="removeMedicine(i)" id="removeMedicineBtn{{i}}">
									<fa-icon [icon]="['fas','trash-alt']"></fa-icon>
								</button>
								<button *ngIf="field.status=='Completed'" class="btn btn-primary btn-xs ms-1"
									matTooltip="Re-Prescribe" type="button" (click)="rePrescribeMedicine(i)"
									id="rePrescribeMedicineBtn{{i}}">
									<fa-icon [icon]="['fas','redo']"></fa-icon>
								</button>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<div class="row mb-2">
			<div class="col text-center">
				<button class="btn btn-info btn-sm" type="button" (click)="AddNewMedicine()"
					id="AddNewMedicineBtn">Add</button>
			</div>
		</div>
		<hr style="margin-top: 10px;margin-bottom: 10px;border: 0;border-top: 1px solid #8394a97d;" />
		<div class="row mb-2">
			<div class="col">
				<button [disabled]="saveMedLoader" class="btn btn-success btn-sm" (click)="saveMedicines()"
					id="saveMedicinesBtn">
					<fa-icon *ngIf="saveMedLoader" [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
					Save
				</button>
				<button class="btn btn-light btn-sm ms-1" (click)="medSection();clearPrescArray();">
					Cancel
				</button>
			</div>
		</div>
		}
		<div class="row mb-2">
			<div class="col">
				<h3 class="fw-bold">Prescription History</h3>
				<table class="table table-bordered" *ngIf="casePrescPdfList.length">
					<thead>
						<tr>
							<th>Date</th>
							<th>Name</th>
							<th>Prescribe By</th>
							<th>Download</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let presc of casePrescPdfList; let i = index">
							<td>{{presc.date}}</td>
							<td>{{getFileName(presc.report_name)}}</td>
							<td>{{presc.prescribe_by}}</td>
							<td>
								<a download href="{{presc.url}}" target="_blank" class="btn btn-xs btn-primary"
									matTooltip="Download Pdf">
									<fa-icon [icon]="['fas','cloud-download-alt']"></fa-icon>
								</a>
							</td>
						</tr>
					</tbody>
				</table>
				<p *ngIf="!casePrescPdfList.length">History Not Found</p>
			</div>
		</div>
		<div class="row mb-2">
			<div class="col">
				<div id="medicineTempTableContainerForCopy1"></div>
			</div>
		</div>
	</div>
</div>